(() => {
  'use strict';
  const config = document.getElementById('sesh-academy-open-media');
  if (!config) return;
  const params = new URLSearchParams(location.search);
  const key = params.get('preview_lesson') ||
    (params.has('beginner_lesson') ? 'fragrance-beginner-' + params.get('beginner_lesson') : '') ||
    (params.has('intermediate_lesson') ? 'fragrance-mid-' + params.get('intermediate_lesson') : '') ||
    (params.has('advanced_fragrance_lesson') ? 'fragrance-adv26-' + params.get('advanced_fragrance_lesson') : '');
  if (!key || !/^[a-z0-9-]+$/.test(key)) return;
  const lang = document.documentElement.lang.startsWith('ar') ? 'ar' : 'en';
  const text = value => value?.[lang] || value?.en || '';
  const make = (tag, cls, value) => {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (value) node.textContent = value;
    return node;
  };
  const safeUrl = value => {
    const url = new URL(value, config.src);
    return url.protocol === 'https:' ? url.href : '';
  };
  const anchor = (url, label, cls) => {
    const a = make('a', cls, label);
    a.href = safeUrl(url);
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    return a;
  };
  function figure(id, item) {
    const f = make('figure', 'sa-open-figure');
    f.dataset.academyMedia = id;
    const url = safeUrl(item.asset || item.url);
    const a = anchor(url, '', 'sa-open-image-link');
    a.setAttribute('aria-label', config.dataset.open);
    const image = make('img');
    image.src = url;
    image.width = item.width;
    image.height = item.height;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = text(item.caption);
    image.addEventListener('error', () => {
      f.classList.add('sa-open-unavailable');
      if (!f.querySelector('.sa-open-error')) f.append(anchor(item.source, config.dataset.unavailable, 'sa-open-error'));
    }, {once: true});
    a.append(image);
    f.append(a);
    const caption = make('figcaption');
    caption.append(make('p', '', text(item.caption)));
    const credit = make('div', 'sa-open-credit');
    credit.append(anchor(item.source, config.dataset.sourceLabel + ' · ' + item.author));
    credit.append(document.createTextNode(' · '));
    credit.append(anchor(item.licenseUrl, item.license));
    credit.append(make('span', 'sa-open-changes', text(item.changes)));
    caption.append(credit, anchor(url, config.dataset.open + ' ↗', 'sa-open-enlarge'));
    f.append(caption);
    return f;
  }
  let payload, observer, queued = false, finished = false;
  function attach() {
    if (finished || !payload) return;
    const record = payload.lessons[key];
    if (!record) { observer?.disconnect(); return; }
    const selectors = {
      'skin-mid': '.sa22-preview-reader .sa22-article',
      'skin-adv': '.sa30-lesson .sa30-content',
      'fragrance-beginner': '.sfa26-reader .sfa26-body',
      'fragrance-mid': '#sfa-mid26-reader',
      'fragrance-adv': '#sfa-adv26-reader'
    };
    const root = document.querySelector(selectors[record.reader]);
    if (!root || !root.querySelector('h2')) return;
    const blocks = Array.from(root.querySelectorAll(':scope > section')).filter(n =>
      !n.className.includes('quiz') && !n.className.includes('check') && !n.className.includes('practice')
    );
    if (!blocks.length) return;
    finished = true;
    observer?.disconnect();
    root.dataset.academyMediaKey = key;
    const images = Array.from(root.querySelectorAll('img'));
    record.media.forEach((id, i) => {
      const item = payload.images[id];
      if (!item) return;
      const expected = new URL(item.asset || item.url, config.src).pathname;
      const existing = images.find(image => {
        try { return new URL(image.getAttribute('src'), location.href).pathname === expected; } catch { return false; }
      });
      if (existing?.closest('figure')) {
        const existingFigure = existing.closest('figure');
        existingFigure.dataset.academyMedia = id;
        existingFigure.classList.add('sa-open-figure');
        const caption = existingFigure.querySelector('figcaption');
        if (caption && !caption.querySelector('.sa-open-enlarge')) {
          caption.append(anchor(item.asset || item.url, config.dataset.open + ' ↗', 'sa-open-enlarge'));
        }
        return;
      }
      const after = blocks[Math.min(i ? 2 : 0, blocks.length - 1)];
      after.after(figure(id, item));
    });
  }
  observer = new MutationObserver(() => {
    if (queued || finished) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; attach(); });
  });
  observer.observe(document.querySelector('main') || document.body, {childList:true, subtree:true});
  fetch(config.dataset.source, {credentials:'same-origin'})
    .then(response => { if (!response.ok) throw new Error('Academy media unavailable'); return response.json(); })
    .then(data => { payload = data; attach(); })
    .catch(() => observer.disconnect());
  setTimeout(() => observer.disconnect(), 30000);
})();
